/* eslint-disable */
const comm = {
  browserType: function () {
    var u = window.navigator.userAgent.toLowerCase();
    // u = 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/16A366&MANA'
    var bIsIpad = u.match(/ipad/i) == "ipad";
    var bIsIphoneOs = u.match(/iphone os/i) == "iphone os";
    var bIsMidp = u.match(/midp/i) == "midp";
    var bIsUc7 = u.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = u.match(/ucweb/i) == "ucweb";
    var bIsAndroid = u.match(/android/i) == "android";
    var bIsCE = u.match(/windows ce/i) == "windows ce";
    var bIsWM = u.match(/windows mobile/i) == "windows mobile";
    var bIsIOS =
      !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/) || u.indexOf("ios") > -1;
    var isPhone = false;
    var isPc = false;
    if (
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM ||
      bIsIOS
    ) {
      isPhone = true;
    } else {
      isPc = true;
    }
    var Obj = {
      userAgent: u,
      isWindows: u.match(/windows/i) == "windows",
      isMac: u.match(/macintosh/i) == "macintosh",
      isWeChat: u.match(/MicroMessenger/i) == "micromessenger",
      isWeibo: u.match(/WeiBo/i) == "weibo",
      isAndroid: u.indexOf("android") > -1 || u.indexOf("adr") > -1,
      isIOS: bIsIOS,
      isQQ: u.match(/qq\//i) == "qq/",
      isPC: isPc,
      isPhone: isPhone,
      isHizhuApp: u.match(/hizhu/i),
      isDingTalk: u.match(/dingtalk/i),
      isManaApp: u.match(/&MANA/i)
    };
    return Obj;

    function versionToNum(str) {
      if (str) {
        var str = str.toString();
        var arr = str.split(".");
        var v_arr = [];
        for (var i = 0; i < 3; i++) {
          var el = arr[i];
          if (el) {
            v_arr.push(Number(el));
          } else {
            v_arr.push(0);
          }
        }
        return v_arr;
      } else {
        return "";
      }
    }
  },
  //获取url参数
  getUrlParam: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return ""; //返回参数值
  },
  //获取url参数
  getParam: function (name, url) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = url.split('?')[1].match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return ""; //返回参数值
  },
  //分享
  shareToweibo(param) {
    var title = param.title;
    var url = param.url;
    var picurl = param.pic;
    var sharesinastring =
      "http://v.t.sina.com.cn/share/share.php?title=" +
      title +
      "&url=" +
      url +
      "&content=utf-8&sourceUrl=" +
      url +
      "&pic=" +
      picurl;
    window.open(sharesinastring);
  },
  //分享到qq空间
  shareToQq(param) {
    var p = {
      url: param.url,
      showcount: "1",
      /*是否显示分享总数,显示：'1'，不显示：'0' */
      desc: "",
      /*默认分享理由(可选)*/
      summary: "",
      /*分享摘要(可选)*/
      title: param.title,
      /*分享标题(可选)*/
      site: "lesty612",
      /*分享来源 如：腾讯网(可选)*/
      pics: param.pic,
      /*分享图片的路径(可选)*/
      style: "202",
      width: 105,
      height: 31
    };
    var s = [];
    for (var i in p) {
      s.push(i + "=" + encodeURIComponent(p[i] || ""));
    }
    let sharesinastring = [
      "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?",
      s.join("&")
    ].join("");
    window.open(sharesinastring);
  },
  /**
   * 用户工具类
   */
  user: {
    getUserName() {
      return localStorage.getItem("email");
    },
    getUserId() {
      return localStorage.getItem("userId");
    }
  }
};

export default comm;



// WEBPACK FOOTER //
// ./src/assets/comm.js